export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13463.30937e56.jpg";